module.exports = __webpack_public_path__ + "static/img/popback2.43e11c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slots/popback2.png
// module id = G7uz
// module chunks = 0